import React, { useState } from "react";
// import emailjs from "emailjs-com"; // Ensure you have installed emailjs-com package
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Contact.css";
const Dalershipform = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    country: "",
    message: "",
    requirement: "",
    consent: false,
  });
  // const [formData, setFormData] = useState(defaultFormData);
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "phone") {
      // Only allow numeric values for phone
      const numericValue = value.replace(/[^0-9]/g, "");
      setFormData((prev) => ({ ...prev, [name]: numericValue }));
    } else if (type === "checkbox") {
      setFormData((prev) => ({ ...prev, [name]: checked }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      console.log("Selected file:", e.target.files[0]);
      setFile(e.target.files[0]);
      setFileName(e.target.files[0].name);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Show loader on form submit
    const formDataToSend = new FormData();
    formDataToSend.append("name", formData.name);
    formDataToSend.append("email", formData.email);
    formDataToSend.append("phone", formData.phone);
    formDataToSend.append("address", formData.address);
    formDataToSend.append("city", formData.city);
    formDataToSend.append("country", formData.country);
    formDataToSend.append("message", formData.message);
    formDataToSend.append("requirement", formData.requirement);

    if (file) {
      formDataToSend.append("attachments", file); // Ensure "attachments" matches the multer field
    }

    try {
      const response = await fetch("http://localhost:4008/career-send-email", {
        method: "POST",
        body: formDataToSend,
      });

      //   console.log("Response:", formData.currentPost);

      if (response.ok) {
        // alert("Email sent successfully!");
        toast.success("Email sent successfully!"); // Success toast
        setFormData({}); // Reset form data
        resetForm(); // Call reset function after success
      } else {
        // alert("Error sending email!");
        toast.error("Error sending email!"); // Error toast
      }
    } catch (error) {
      //   alert("Error sending email!");
      toast.error("Error sending email!"); // Error toast
    } finally {
      setLoading(false); // Hide loader after submission
    }
  };

  const defaultFormData = {
    name: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    country: "",
    message: "",
    requirement: "",
    consent: false,
  };

  // Reset form function
  const resetForm = () => {
    setFormData(defaultFormData); // Reset all fields to their initial state
  };

  return (
    <div className="contact-form-contact">
      <div className="export-contact-form">
        <h3>Career At Dasmesh Group</h3>
        <p id="contact-p-tag">
          Working at Dasmesh is more than a job; it's a career in an industry
          that makes a difference in the lives of millions of farmers around the
          world.
        </p>
        <p id="contact-p-tag">
          At Dasmesh, we believe that when our employees succeed, our business
          succeeds. We make sure all of our employees have the tools they need
          to be successful.
        </p>
        <p id="conetct-p-tag-top-form">
          Fill in the form below or send your requirement directly on{" "}
          <span>hrd@dasmesh.com</span> and we will get in touch with you.
        </p>
        <div className="form-container">
          <form
            onSubmit={handleSubmit}
            method="POST"
            encType="multipart/form-data"
          >
            <div className="form-row">
              <div className="form-group">
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={handleChange}
                  
                />
              </div>
              <div className="form-group">
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={handleChange}
                  
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <input
                  type="text"
                  id="phone"
                  name="phone"
                  placeholder="Phone No."
                  value={formData.phone}
                  onChange={handleChange}
                  
                />
              </div>
              <div className="form-group">
                <input
                  type="text"
                  id="address"
                  name="address"
                  placeholder="Local Address"
                  value={formData.address}
                  onChange={handleChange}
                  
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <input
                  type="text"
                  id="city"
                  name="city"
                  placeholder="city"
                  value={formData.city}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <input
                  type="text"
                  id="country"
                  name="country"
                  placeholder="country"
                  value={formData.country}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <input
                  type="text"
                  id="message"
                  name="message"
                  placeholder="message"
                  value={formData.message}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="file-upload-container">
              <div className="file-name-display">
                {fileName || "Attach Resume"}
              </div>
              <label htmlFor="file-upload" className="file-upload-button">
                Choose File
              </label>
              <input
                id="file-upload"
                type="file"
                name="attachments"
                onChange={handleFileChange}
                className="file-input"
                multiple
              />
            </div>
            <div className="form-group">
              <textarea
                id="requirement"
                name="requirement"
                placeholder="Tell us about yourself"
                value={formData.requirement}
                onChange={handleChange}
              ></textarea>
            </div>
            <div className="contact-checkbox-form">
              <input type="checkbox"  />
              <p>
                By checking this box, you consent and agree to DASMESH sending
                text messages or placing voice calls (live or pre-recorded), to
                the telephone number you have provided, for advertising and
                telemarketing purposes. You understand that you are not required
                to sign or enter into this agreement as a condition of
                purchasing any property, goods, or services. You further accept
                our privacy policy and Legal Disclaimer. *
              </p>
            </div>
            {/* <span> <input type="submit" name="submit" value="Send" /> </span> */}
            <button type="submit" disabled={loading}>
              {loading ? "Sending..." : "Send Email"}
            </button>
          </form>
          {/* Toast container */}
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            closeOnClick
            pauseOnHover
            draggable
          />
        </div>
      </div>
    </div>
  );
};

export default Dalershipform;
